import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { GeneralObject } from "@vocollege/app";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";

export const getExcelData = (
  data: any,
  queryFilters: GeneralObject | null,
  label: string
) => {
  if (!data?.statistics) {
    return null;
  }

  const result: DownloadExcelButtonProps = {
    filename: "Allman_statistik",
    sheets: [],
  };

  const commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: label,
          },
        ],
      },
      "",
      queryFilters?.to
        ? `${I18n.get.misc.to}: ${queryFilters.to}`
        : `${I18n.get.misc.to}: -`,
    ],
    [],
  ];

  const summarySheet: Sheet = {
    name: label,
    rows: [...commonHead],
  };

  summarySheet.rows?.push(
    [I18n.get.statistics.labels.numberOfRegionalVoCollege, "", data.statistics.regions?.length || 0],
    [I18n.get.statistics.labels.numberOfLocalVoCollege, "", data.statistics.localColleges?.length || 0],
    [I18n.get.statistics.labels.numberOfEmployer, "", data.statistics.employers?.length || 0],
    [I18n.get.statistics.labels.numberOfEducators, "", data.statistics.educators?.length || 0]
  );
  result.sheets?.push(summarySheet);

  if (data.statistics.employers?.length) {
    const employersPerTypeSheet: Sheet = {
      name: I18n.get.statistics.labels.employerPerType,
      rows: [...commonHead],
    };

    Object.keys(I18n.get.group.employerTypes).forEach((employerType: string) => {
      const value = data.statistics.employers.filter((v: GeneralObject) => {
        return v.employer_type?.indexOf(employerType) > -1;
      }).length;
      employersPerTypeSheet.rows?.push([
        I18n.get.group.employerTypes[employerType],
        "",
        value,
      ]);
    });

    result.sheets?.push(employersPerTypeSheet);
  }

  if (data.statistics.educators?.length) {
    const educatorsPerTypeSheet: Sheet = {
      name: I18n.get.statistics.labels.educatorPerType,
      rows: [...commonHead],
    };

    Object.keys(I18n.get.group.educatorTypes).forEach((educatorType: string) => {
      const value = data.statistics.educators.filter((v: GeneralObject) => {
        return v?.educator_type?.indexOf(educatorType) > -1;
      }).length;
      educatorsPerTypeSheet.rows?.push([
        I18n.get.group.educatorTypes[educatorType],
        "",
        value,
      ]);
    });

    result.sheets?.push(educatorsPerTypeSheet);
  }

  if (data.statistics.educations?.length) {
    const educationsSheet: Sheet = {
      name: I18n.get.education.labels.educations,
      rows: [...commonHead],
    };

    data.statistics.educations.forEach((v: GeneralObject) => {
      educationsSheet.rows?.push([v.title, "", v.total_usages]);
    });

    result.sheets?.push(educationsSheet);
  }

  return result;
};
